import { SyncJobStatus, SyncJobType } from "@/types/pms";

export const syncJobStatusClass: Record<SyncJobStatus, string> = {
  [SyncJobStatus.PENDING]: "bg-muted text-muted-foreground",
  [SyncJobStatus.RUNNING]: "bg-blue-100 text-blue-800",
  [SyncJobStatus.COMPLETED]: "bg-green-100 text-green-800",
  [SyncJobStatus.FAILED]: "bg-red-100 text-red-800",
  [SyncJobStatus.CANCELLED]: "bg-yellow-100 text-yellow-800",
};

export const syncJobStatusPulses: Record<SyncJobStatus, boolean> = {
  [SyncJobStatus.PENDING]: false,
  [SyncJobStatus.RUNNING]: true,
  [SyncJobStatus.COMPLETED]: false,
  [SyncJobStatus.FAILED]: false,
  [SyncJobStatus.CANCELLED]: false,
};

export const syncJobTypeClass: Record<SyncJobType, string> = {
  [SyncJobType.FULL]: "bg-blue-100 text-blue-800",
  [SyncJobType.INCREMENTAL]: "bg-muted text-muted-foreground",
  [SyncJobType.SELECTIVE]: "bg-purple-100 text-purple-800",
};
